export default __webpack_public_path__ + "static/media/smileEvening.c0cfcc42.svg";